import React from "react";

import { Body, Button, Header, Image, Logo, ClickLink, Input } from "../components";
import {Link} from "react-router-dom";
import logo from "../cookin-lab1000.gif";


//Functional Component
const Home = () => {
  return (
    <div>
      <Header>
        <Link style={{"margin-right": "40px", "margin-top": "15px", "color":"black"}} to="mint">Mint</Link>
        <a style={{"margin-right": "40px", "margin-top": "15px", "color":"black"}} target="_blank" href="https://elementblocks.org/molecules.html">About</a>
      </Header>
      <Body>
        <br/>
        <br/>
        <Logo src={logo} alt="ChemScripts-logo" />
        <br/>
        <h2>ChemScripts</h2>
        <br/>
        <br/>
        <span class="nes-text is-disabled">onchain molecules</span>

        <br/>


      </Body>
    </div>
  );
};

export default Home;
